import React from 'react'
import './the-artist.css'
import img from '../../images/art-4.svg'

import david from "../../images/shangu_updated/David.JPG"
const TheArtist = () => {
    return (
        <div className='the-artist'>
            <div className='the-artist-heading'>
                <div>
                    <h2>
                    Meet our <span>Artist!</span>
                    </h2>
                </div>
            </div>

            <div className='the-artist-body'>
                {/* <img src={} className="" /> */}
            </div>

            <div className='artist-content'>
                <div className='top-content'>
                    <p>
                        {/* <span>I'm David Huynh</span> */}
                        David is a world renowned cartoon artist best known for his Cartoon art on real life Dollar Bills that notoriously sell out within minutes of launching. David has already built a passionate community around his artwork and a consistent resale market that will extend into his NFT career.
                    </p>
                </div>
                <div className='bottom-content'>
                    <img src={david} alt='' />
                    <div className='artist-text'>
                        <h1>I'm David Huynh</h1>
                        <p>
                        A word from David “Hey everyone and welcome to what will be the first of many of my NFT drops. I remember back when I was younger, my favourite time of the year was always Chinese New Year! Being born into an asian house hold, it comes with the territory but there was always something so magical about this time of year that intrigued me the most. <br/><br/>


My goal is to share that same experience and feeling of community and gift giving with The Legends of Shangu NFT collection whilst also creating a sound investment and eco-system for holders that will continually scale as we develop our franchise!

                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TheArtist
